"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDisclosure = void 0;

var react_1 = require("react");

var use_did_update_effect_1 = require("./use-did-update-effect");

function useDisclosure(props) {
  if (props === void 0) {
    props = {};
  }

  var _a = props.defaultOpenState,
      defaultOpenState = _a === void 0 ? false : _a,
      _b = props.openState,
      openState = _b === void 0 ? false : _b,
      onCloseProp = props.onClose,
      onOpenProp = props.onOpen;

  var _c = __read((0, react_1.useState)(defaultOpenState || openState), 2),
      isOpen = _c[0],
      setIsOpen = _c[1];

  var close = (0, react_1.useCallback)(function () {
    setIsOpen(false);
    onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
  }, [isOpen, onCloseProp]);
  var open = (0, react_1.useCallback)(function () {
    setIsOpen(true);
    onOpenProp === null || onOpenProp === void 0 ? void 0 : onOpenProp();
  }, [isOpen, onOpenProp]);
  var toggle = (0, react_1.useCallback)(function () {
    var action = isOpen ? close : open;
    action();
  }, [isOpen, open, close]);
  (0, use_did_update_effect_1.useDidUpdateEffect)(function () {
    if (openState) {
      open();
    }
  }, [openState]);
  return {
    isOpen: isOpen,
    open: open,
    close: close,
    toggle: toggle
  };
}

exports.useDisclosure = useDisclosure;